<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 7.42L16.58 6L12 10.59L7.40997 6L6 7.41L10.58 12L6 16.59L7.40997 18L12 13.41L16.58 18L18 16.59L13.41 12L18 7.42Z" fill="currentColor"/>
</svg>
